/* eslint-disable linebreak-style */
import {
	ButtonView,
	View,
	Template
} from '@src/plugins/ckeditor5-ui/src/index';
import { icons } from '@src/plugins/ckeditor5-core/src/index';
import '../theme/linkForm.css';
export default class LinkForm extends View {
	constructor( locale, options ) {
		super( locale );
		const t = locale.t;
		this.options = options;
		this.selectTemplate = this._createselectView();
		// this.saveButtonView = this._createButton( t( 'Save' ), icons.check, 'ck-button-save', 'submit' );
		// this.saveButtonView.type = 'button';
		this.cancelButtonView = this._createButton( t( 'Cancel' ), icons.cancel, 'ck-button-cancel', 'cancel' );
		this.setTemplate( {
			tag: 'div',
			attributes: {
				class: 'ck-selectfile-form',
				// https://github.com/ckeditor/ckeditor5-link/issues/90
				tabindex: '-1'
			},
			children: [
				{
					tag: 'p',
					attributes: {
						class: 'ck-selectfile-form-title'
					},
					children: [
						'资料文件引用'
					]
				},
				this.selectTemplate,
				// this.saveButtonView,
				this.cancelButtonView
			]
		} );
	}
	_createButton( label, icon, className, eventName ) {
		const button = new ButtonView( this.locale );

		button.set( {
			label,
			// icon,
			tooltip: true,
			withText: true
		} );

		button.extendTemplate( {
			attributes: {
				class: className
			}
		} );

		if ( eventName ) {
			button.delegate( 'execute' ).to( this, eventName );
		}

		return button;
	}
	_createselectView() {
		const bind = this.bindTemplate;
		return new Template( {
			tag: 'ul',
			attributes: {
				class: 'select-file-ul'
			},
			children: this.options.map( item => ( {
				tag: 'li',
				attributes: {
					value: item.value,
					class: 'select-file-li'
				},
				children: [
					{
						tag: 'span',
						attributes: {
   				    class: 'select-file-name'
						},
						children: [
							item.name
						]
					},
					{
						tag: 'span',
						attributes: {
							value: item.value,
							class: 'select-file-button'
						},
						children: [
							'引用附件'
						],
						on: {
							click: bind.to( 'clickLiButton' )
						}
					}
				]

			} ) )
		} );
	}
}
